import React, { useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import TenantManagement from './TenantManagement';

const TenantManagementPage = () => {
  const { currentUser, isTokenExpired } = useContext(AuthContext);

  // Only super_admin can access this page
  const isSuperAdmin = currentUser?.role === 'super_admin';

  // Session expired state
  if (isTokenExpired) {
    return (
      <div style={{ padding: '40px', textAlign: 'center' }}>
        <h2>⚠️ Session Expired</h2>
        <p>Your session has expired. Please log in again to continue.</p>
      </div>
    );
  }

  // Check authorization
  if (!isSuperAdmin) {
    return (
      <div style={{ padding: '40px', textAlign: 'center' }}>
        <h2>Access Denied</h2>
        <p>You do not have permission to access this page. This page is only accessible to Super Admins.</p>
      </div>
    );
  }

  // Render unified tenant management (includes billing, usage, and impersonation)
  return <TenantManagement />;
};

export default TenantManagementPage;
